import { CreateSubscriptionBundleInput } from 'generated/graphql';
import { mapPriceValueForInput } from './editBundle.vm.mapper';
import { ButtonVariant } from '@client/new/pages/workout/components/addFromLibrary/mappers';
import { CreateBundleDispatcher, CreateModalSteps } from './createBundle.vm';
import { CreateFormValues } from './priceFormSchemas';

export const mapToCreateBundleInput = (
  values: CreateFormValues,
  creatorId: number,
): CreateSubscriptionBundleInput => ({
  annualPriceCents: mapPriceValueForInput({
    updatePriceEnabled: values.annualPriceEnabled,
    updatePrice: values.annualPrice,
  }),
  monthlyPriceCents: mapPriceValueForInput({
    updatePriceEnabled: values.monthlyPriceEnabled,
    updatePrice: values.monthlyPrice,
  }),
  freeTrial: {
    annual: values.annualFreeTrial,
    monthly: values.monthlyFreeTrial,
  },
  influencerId: creatorId,
});

export const getStepCta = ({
  step,
  dispatch,
  isSubmitting,
}: {
  step: CreateModalSteps;
  dispatch: CreateBundleDispatcher;
  isSubmitting: boolean;
}) => {
  switch (step) {
    case 1:
      return [
        {
          title: 'Continue',
          onClick: () => dispatch('setStep', 2),
        },
      ];
    case 2:
      return [
        {
          title: 'Back',
          onClick: () => dispatch('setStep', 1),
          variant: 'text' as ButtonVariant,
        },
        {
          title: 'Continue',
          onClick: () => dispatch('setStep', 3),
        },
      ];
    case 3:
      return [
        {
          title: 'Back',
          onClick: () => dispatch('setStep', 2),
          variant: 'text' as ButtonVariant,
        },
        {
          title: 'Save & Proceed',
          onClick: () => dispatch('create'),
          submitting: isSubmitting,
        },
      ];
    default:
      return [
        {
          title: 'Continue',
          onClick: () => dispatch('setStep', 2),
        },
      ];
  }
};
